import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { logger, notify } from '@/shared';

function nonBlank(value: string | undefined): string | undefined {
  return value !== undefined && value.trim() !== '' ? value : undefined;
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      const meta = query.meta;
      if (meta?.sentryOnError !== false) {
        logger.error(
          'query error',
          {
            surface: 'react-query',
            operation: 'query',
            queryKey: query.queryKey,
            meta,
          },
          error
        );
      }

      if (meta?.toastOnError === false) {
        return;
      }
      notify.error(nonBlank(meta?.toast?.title) ?? 'Failed to load data', error, {
        description: nonBlank(meta?.toast?.description),
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      const meta = mutation.meta;
      if (meta?.sentryOnError !== false) {
        logger.error(
          'mutation error',
          {
            surface: 'react-query',
            operation: 'mutation',
            mutationKey: mutation.options.mutationKey,
          },
          error
        );
      }
      if (meta?.toastOnError === false) {
        return;
      }
      notify.error('Request failed', error);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      gcTime: 1000 * 60 * 5, // 5 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
